import React from 'react';
import CloseIcon from "@mui/icons-material/Close";
import { Modal } from "@mui/material";
import WarningIcon from '@mui/icons-material/Warning';
import { useTranslation } from "react-i18next";

const ErrorModal = ({ errorMessage, handleErrorModal }) => {
    const { t } = useTranslation();

    return (
        <Modal
            open={errorMessage}
            onClose={handleErrorModal}
            hideBackdrop={false}
        >
            <div className="equipment-modal"  role="error-modal" >
                <div className="description-title">
                    <button
                        type="button"
                        className="close-compare"
                        onClick={handleErrorModal}
                        role={'modal'}
                    >
                        <CloseIcon fontSize="small" />
                    </button>
                    <div className="description-title-div">{t('error')}</div>
                </div>
                <div className="description-body">
          <span className="warning-icon">
            <WarningIcon fontSize="small" />
          </span>
                    {errorMessage === "COMPARE-API-001" ? (
                        <p className="description-body-div">{t('redirectErrorMessage')}</p>
                    ) : (
                        <p className="description-body-div">{t('serviceErrorMessage')}</p>
                    )}
                </div>
                <div className="modal-footer">
                    <div className="btn-default" onClick={handleErrorModal}>
                        {t('close')}
                    </div>
                </div>
            </div>
        </Modal>
    );
};

export default ErrorModal;
